import api from "@/services/api";

export const state = {
  activities: [],
  activity: {},
};

export const mutations = {
  INIT_ACTIVITIES(state, payload) {
    state.activities = payload;
  },
  INIT_ACTIVITY(state, payload) {
    state.activity = payload;
  },
};

export const actions = {
  getActivities({ commit }, payload) {
    return api.getActivities(payload).then((response) => {
      commit("INIT_ACTIVITIES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getActivityById({ commit }, payload) {
    return api.getActivityById(payload).then((response) => {
      commit("INIT_ACTIVITY", response.data.data);
    });
  },
};

export const getters = {
  getActivities: (state) => state.activities,
  getActivity: (state) => state.activity,
};
